export const EnglishCounties = `
Bedfordshire
Berkshire
Bristol
Buckinghamshire
Cambridgeshire
Cheshire
City of London
Cornwall
Cumbria
Derbyshire
Devon
Dorset
Durham
East Riding of Yorkshire
East Sussex
Essex
Gloucestershire
Greater London
Greater Manchester
Hampshire
Herefordshire
Hertfordshire
Isle of Wight
Kent
Lancashire
Leicestershire Lincolnshire
Merseyside
Norfolk
North Yorkshire
Northamptonshire
Northumberland
Nottinghamshire
Oxfordshire
Rutland
Shropshire
Somerset
South Yorkshire
Staffordshire
Suffolk
Surrey
Tyne & Wear
Warwickshire
West Midlands
West Sussex
West Yorkshire
Wiltshire
Worcestershire
    `;